import { RouteObject } from 'react-router-dom'
import { makeCbUnicoSuccessPage } from '../../factories/pages/static-pages-factory'
import PathConstants from '../path-contants'
import FirstAccessRoutesBuilder from './first-access-routes-builder'

const { CB_UNICO_SUCCESS } = PathConstants.StaticRoutes

const UnauthenticatedRoutesBuilder = (): RouteObject[] => {
  return [
    ...FirstAccessRoutesBuilder(),
    {
      path: CB_UNICO_SUCCESS.value,
      element: makeCbUnicoSuccessPage()
    }
  ]
}
export default UnauthenticatedRoutesBuilder
